export { ProductService } from './product';

/* Interfaces */
export type {
  Product,
  Price,
  PriceWithDiscount,
  ProductDetails,
  ProductReview,
  ProductReviewSummary,
  ProductEnrichmentDetails,
  ProductEnrichmentCoreMaterial,
  ProductEnrichmentSizeFit,
  ProductEnrichmentTechnicalSpecs,
  ProductSizeGuide,
  ProductResult,
  Money,
  PriceRaw,
  PriceWithDiscountRaw,
  Option,
  Attribute,
  ProductsResponse,
  AttributeType,
  UnsupportedAttributeType,
  Variant,
  Term,
  ProductDiscount,
  ProductHit,
  Attributes,
  ProductDiscountWithImage,
  Facet
} from './interfaces';
